import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

/**
 * Human names for the inspector's «Тип» row. Kinds are Fabric object types and
 * the plugins' `data.kind` strings, not a domain enum — only the inspector needs
 * them, so the table lives here. Translate with `t(objectKindLabel(kind))`.
 */
export const OBJECT_KIND_LABELS: Readonly<Record<string, MessageDescriptor>> = {
  textbox: msg`Текст`,
  'i-text': msg`Текст`,
  text: msg`Текст`,
  rect: msg`Прямоугольник`,
  circle: msg`Круг`,
  ellipse: msg`Эллипс`,
  triangle: msg`Треугольник`,
  polygon: msg`Многоугольник`,
  image: msg`Изображение`,
  'placeholder-text': msg`Текстовый плейсхолдер`,
  'placeholder-image': msg`Плейсхолдер изображения`,
  group: msg`Группа`,
  'layout-block': msg`Макет`,
};

const UNKNOWN_KIND_LABEL = msg`Объект`;

export function objectKindLabel(kind: string | undefined): MessageDescriptor {
  return (kind && OBJECT_KIND_LABELS[kind]) || UNKNOWN_KIND_LABEL;
}
